
import { defineComponent, watch } from "vue";
import useMousePosition from "./hook/useMousePosition";
import useRequest from "./hook/useRequest";
// 定义接口
interface PersonI {
    name: string;
    age: number;
}
export default defineComponent({
    name: "App",
    setup() {
        const { x, y } = useMousePosition();
        // const { loading, data, errorMag } = useRequest<PersonI>('/data/obj.json');
        const { loading, data, errorMag } = useRequest<PersonI[]>('/data/arr.json');
        watch(data, () => {
            console.log(data.value?.length);
        })
        return {
            x,
            y,
            loading,
            data,
            errorMag,
        };
    },
});
